export function parsePushDetails(raw: unknown): { activated: number; errors: string[] } {
  try {
    const details = raw ? (typeof raw === 'string' ? JSON.parse(raw) : raw) : null;
    return {
      activated: typeof details?.activated === 'number' ? details.activated : 0,
      errors: Array.isArray(details?.errors) ? details.errors : [],
    };
  } catch {
    return { activated: 0, errors: [] };
  }
}
